var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/naming-convention */
import { darken, unstable_createMuiStrictModeTheme } from '@material-ui/core/styles';
import { CheckCircle, Error, Info, Warning } from '@material-ui/icons';
import { createElement } from 'react';
import { IconCheckBox, IconCheckBoxOutlineBlank, IconChevronDown, IconIndeterminateCheckBox } from '../component';
import { createShadow } from '../util/themeHelper';
// brand colour configuration
export var basePaletteOptions = {
    action: {
        disabled: '#00000054',
        hoverOpacity: 0.08,
    },
    background: {
        default: '#ffffff',
        paper: '#ffffff',
        subtle: '#f5f5f5',
    },
    common: {
        black: '#000000',
        white: '#ffffff',
    },
    divider: '#e0e0e0',
    error: {
        contrastText: '#000000e6',
        dark: '#aa221a',
        light: '#ec9b96',
        main: '#fe6057',
    },
    info: {
        contrastText: '#000000e6',
        dark: '#5184a4',
        light: '#b2d2e6',
        main: '#66a6cd',
    },
    primary: {
        contrastText: '#ffffff',
        dark: '#e26d00',
        light: '#ff9d42',
        main: '#ff830f',
    },
    secondary: {
        contrastText: '#ffffff',
        dark: '#0554cb',
        light: '#448fff',
        main: '#0c67ef',
    },
    success: {
        contrastText: '#000000e6',
        dark: '#108b50',
        light: '#8ad6b2',
        main: '#15ae65',
    },
    text: {
        disabled: '#000000ab',
        hint: '#000000ab',
        primary: '#000000eb',
        secondary: '#000000cc',
    },
    warning: {
        contrastText: '#000000e6',
        dark: '#c8ad4c',
        light: '#fdecaf',
        main: '#fbd960',
    },
};
export var applyThemePalette = function (paletteOptions) {
    return unstable_createMuiStrictModeTheme({
        palette: __assign(__assign({}, paletteOptions), { contrastThreshold: 3, tonalOffset: {
                dark: 0.2,
                light: 0.5,
            }, type: 'light' }),
        shadows: [
            'none',
            createShadow([0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0], [0.08, 0.06, 0.04]),
            createShadow([0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0], [0.08, 0.06, 0.04]),
            createShadow([0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0], [0.08, 0.06, 0.04]),
            createShadow([0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0], [0.08, 0.06, 0.04]),
            createShadow([0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0], [0.08, 0.06, 0.04]),
            createShadow([0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0], [0.08, 0.06, 0.04]),
            createShadow([0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1], [0.08, 0.06, 0.04]),
            createShadow([0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2], [0.08, 0.06, 0.04]),
            createShadow([0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2], [0.08, 0.06, 0.04]),
            createShadow([0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3], [0.08, 0.06, 0.04]),
            createShadow([0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3], [0.08, 0.06, 0.04]),
            createShadow([0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4], [0.08, 0.06, 0.04]),
            createShadow([0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4], [0.12, 0.06, 0.04]),
            createShadow([0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4], [0.12, 0.06, 0.04]),
            createShadow([0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5], [0.12, 0.06, 0.04]),
            createShadow([0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5], [0.12, 0.06, 0.04]),
            createShadow([0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5], [0.12, 0.06, 0.04]),
            createShadow([0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6], [0.12, 0.06, 0.04]),
            createShadow([0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6], [0.14, 0.1, 0.06]),
            createShadow([0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7], [0.14, 0.1, 0.06]),
            createShadow([0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7], [0.14, 0.1, 0.06]),
            createShadow([0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7], [0.14, 0.1, 0.06]),
            createShadow([0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8], [0.14, 0.1, 0.06]),
            createShadow([0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8], [0.14, 0.1, 0.06]),
        ],
        shape: {
            borderRadius: 8,
        },
    });
};
export var applyThemeTypography = function (theme) {
    return unstable_createMuiStrictModeTheme(__assign(__assign({}, theme), { typography: {
            allVariants: {
                fontFamily: 'Nunito, sans-serif',
                fontKerning: 'normal',
                fontWeight: 600,
                letterSpacing: 0,
                textRendering: 'optimizeLegibility',
                textTransform: 'none',
            },
            body1: {
                fontSize: theme.typography.pxToRem(16),
                lineHeight: theme.typography.pxToRem(28),
            },
            body2: {
                fontSize: theme.typography.pxToRem(14),
                lineHeight: theme.typography.pxToRem(24),
            },
            button: {
                fontSize: theme.typography.pxToRem(14),
                fontWeight: 700,
                lineHeight: theme.typography.pxToRem(24),
            },
            caption: {
                fontSize: theme.typography.pxToRem(12),
                letterSpacing: theme.typography.pxToRem(0.5),
                lineHeight: theme.typography.pxToRem(20),
            },
            fontFamily: 'Nunito, sans-serif',
            fontSize: 16,
            fontWeightBold: 800,
            fontWeightLight: 600,
            fontWeightMedium: 700,
            fontWeightRegular: 600,
            h1: {
                fontSize: theme.typography.pxToRem(32),
                fontWeight: 700,
                letterSpacing: theme.typography.pxToRem(-0.5),
                lineHeight: theme.typography.pxToRem(38),
            },
            h2: {
                fontSize: theme.typography.pxToRem(24),
                fontWeight: 700,
                letterSpacing: theme.typography.pxToRem(-0.5),
                lineHeight: theme.typography.pxToRem(32),
            },
            h3: {
                fontSize: theme.typography.pxToRem(18),
                fontWeight: 700,
                letterSpacing: theme.typography.pxToRem(-0.2),
                lineHeight: theme.typography.pxToRem(28),
            },
            h4: {
                fontSize: theme.typography.pxToRem(16),
                fontWeight: 700,
                lineHeight: theme.typography.pxToRem(24),
            },
            h5: {
                fontSize: theme.typography.pxToRem(14),
                fontWeight: 800,
                letterSpacing: theme.typography.pxToRem(0.3),
                lineHeight: theme.typography.pxToRem(24),
            },
            h6: {
                fontSize: theme.typography.pxToRem(11),
                fontWeight: 800,
                letterSpacing: theme.typography.pxToRem(0.1),
                lineHeight: theme.typography.pxToRem(16),
            },
            htmlFontSize: 16,
            overline: {
                fontSize: theme.typography.pxToRem(14),
                letterSpacing: theme.typography.pxToRem(1),
                lineHeight: theme.typography.pxToRem(16),
                textTransform: 'uppercase',
            },
            subtitle1: {
                fontSize: theme.typography.pxToRem(48),
                fontWeight: 700,
                lineHeight: theme.typography.pxToRem(72),
            },
            subtitle2: {
                fontSize: theme.typography.pxToRem(40),
                fontWeight: 700,
                lineHeight: theme.typography.pxToRem(60),
            },
        } }));
};
// themeStage3 - inherit stage2, apply deeper component level customisation and default properties.
export var applyThemeComponents = function (theme) {
    var _a, _b, _c;
    return unstable_createMuiStrictModeTheme(__assign(__assign({}, theme), { overrides: {
            MuiAccordion: {
                root: {
                    '&$expanded': {
                        margin: '0',
                    },
                    '&.MuiPaper-outlined': {
                        border: 'none',
                        borderLeft: "solid 4px " + theme.palette.secondary.light,
                    },
                    '&:before': {
                        backgroundColor: 'none',
                    },
                    background: 'none',
                    boxShadow: 'none',
                },
            },
            MuiAccordionDetails: {
                root: {
                    padding: theme.spacing(0, 1, 2),
                },
            },
            MuiAccordionSummary: {
                content: {
                    '&$expanded': {
                        margin: theme.spacing(1.5, 0),
                    },
                },
                expandIcon: {
                    color: theme.palette.secondary.main,
                },
                root: {
                    '&$expanded': {
                        minHeight: theme.spacing(6),
                    },
                    padding: theme.spacing(0, 1),
                },
            },
            MuiAlert: {
                action: {
                    alignItems: 'flex-start',
                    paddingTop: theme.spacing(1),
                },
                filledError: {
                    color: theme.palette.primary.contrastText,
                },
                filledInfo: {
                    backgroundColor: theme.palette.secondary.dark,
                },
                filledSuccess: {
                    color: theme.palette.primary.contrastText,
                },
                filledWarning: {
                    color: theme.palette.primary.contrastText,
                },
                icon: {
                    color: 'inherit',
                },
                standardError: {
                    '& .MuiAlert-icon': {
                        color: theme.palette.error.dark,
                    },
                    borderColor: theme.palette.error.main,
                    borderStyle: 'solid',
                    borderWidth: '1px',
                    color: darken(theme.palette.error.main, 0.6),
                },
                standardInfo: {
                    '& .MuiAlert-icon': {
                        color: theme.palette.secondary.main,
                    },
                    borderColor: theme.palette.secondary.main,
                    borderStyle: 'solid',
                    borderWidth: '1px',
                    color: theme.palette.secondary.dark,
                },
                standardSuccess: {
                    borderColor: theme.palette.success.dark,
                    borderStyle: 'solid',
                    borderWidth: '1px',
                },
                standardWarning: {
                    '& .MuiAlert-icon': {
                        color: darken(theme.palette.warning.main, 0.6),
                    },
                    borderColor: theme.palette.warning.dark,
                    borderStyle: 'solid',
                    borderWidth: '1px',
                    color: theme.palette.warning.contrastText,
                },
            },
            MuiAlertTitle: {
                root: {
                    fontWeight: 700,
                },
            },
            MuiAutocomplete: {
                inputRoot: {
                    '&[class*="MuiOutlinedInput-root"]': {
                        padding: 0,
                    },
                },
                option: {
                    lineHeight: theme.typography.pxToRem(28),
                },
            },
            MuiButton: {
                containedPrimary: {
                    '&:hover': {
                        backgroundColor: theme.palette.primary.dark,
                    },
                },
                containedSecondary: {
                    '&:hover': {
                        backgroundColor: theme.palette.secondary.light,
                    },
                },
                endIcon: {
                    '&$iconSizeLarge': {
                        marginLeft: theme.spacing(1),
                        marginRight: theme.spacing(-0.5),
                    },
                    '&$iconSizeSmall': {
                        marginLeft: theme.spacing(0.5),
                        marginRight: theme.spacing(-0.5),
                    },
                    marginLeft: theme.spacing(0.75),
                    marginRight: theme.spacing(-0.5),
                },
                outlined: __assign(__assign({ '&$disabled': {
                        borderWidth: '2px',
                    }, '&.square': {
                        borderRadius: '4px',
                    } }, theme.typography.button), { borderColor: theme.palette.grey[300], borderRadius: '18px', borderWidth: '2px', height: '36px', minWidth: '30px', padding: theme.spacing(0.75, 1.5) }),
                outlinedPrimary: {
                    '&$disabled': {
                        borderColor: theme.palette.action.disabledBackground,
                        borderWidth: '2px',
                    },
                    '&:hover': {
                        borderWidth: '2px',
                    },
                    borderWidth: '2px',
                },
                outlinedSecondary: {
                    '&$disabled': {
                        borderColor: theme.palette.action.disabledBackground,
                        borderWidth: '2px',
                    },
                    '&:hover': {
                        borderColor: theme.palette.text.primary,
                        borderWidth: '2px',
                        color: theme.palette.text.primary,
                    },
                    borderColor: theme.palette.text.primary,
                    borderWidth: '2px',
                    color: theme.palette.text.primary,
                },
                root: __assign(__assign({ '&.iconOnly': {
                        '& .MuiSvgIcon-root': {
                            fontSize: theme.typography.pxToRem(18),
                        },
                        height: '32px',
                        minWidth: '26px',
                        padding: theme.spacing(0.75),
                        width: '32px',
                    }, '&.square': {
                        borderRadius: '4px',
                    } }, theme.typography.button), { borderRadius: '18px', height: '36px', minWidth: '50px', padding: theme.spacing(0.75, 1.5) }),
                sizeLarge: {
                    '&.iconOnly': {
                        '& .MuiSvgIcon-root': {
                            fontSize: theme.typography.pxToRem(22),
                        },
                        height: '40px',
                        padding: theme.spacing(1),
                        width: '40px',
                    },
                    '&.square': {
                        borderRadius: '4px',
                    },
                    borderRadius: '22px',
                    fontSize: theme.typography.pxToRem(16),
                    height: '42px',
                    letterSpacing: theme.typography.pxToRem(-0.2),
                    lineHeight: theme.typography.pxToRem(28),
                    padding: theme.spacing(1, 2),
                },
                sizeSmall: {
                    '&.iconOnly': {
                        '& .MuiSvgIcon-root': {
                            fontSize: theme.typography.pxToRem(16),
                        },
                        height: '26px',
                        padding: theme.spacing(0.5),
                        width: '26px',
                    },
                    '&.square': {
                        borderRadius: '4px',
                    },
                    borderRadius: '15px',
                    fontSize: theme.typography.pxToRem(13),
                    height: '30px',
                    lineHeight: theme.typography.pxToRem(22),
                    padding: theme.spacing(0.5, 1),
                },
                startIcon: {
                    '&$iconSizeLarge': {
                        marginLeft: theme.spacing(-0.5),
                        marginRight: theme.spacing(1),
                    },
                    '&$iconSizeSmall': {
                        marginLeft: theme.spacing(-0.5),
                        marginRight: theme.spacing(0.5),
                    },
                    marginLeft: theme.spacing(-0.5),
                    marginRight: theme.spacing(0.75),
                },
                text: __assign(__assign({}, theme.typography.button), { borderRadius: '18px', height: '36px', minWidth: '30px', padding: theme.spacing(0.75, 1.5) }),
                textSecondary: {
                    color: theme.palette.secondary.main,
                },
            },
            MuiCheckbox: {
                root: {
                    '& .MuiSvgIcon-root': {
                        border: 'solid 2px',
                        borderColor: theme.palette.common.black,
                        borderRadius: '6px',
                        fontSize: theme.typography.pxToRem(24),
                        height: '24px',
                        width: '24px',
                    },
                    '&$disabled': {
                        '& .MuiSvgIcon-root': {
                            backgroundColor: theme.palette.action.disabledBackground,
                            borderColor: theme.palette.action.disabled,
                            color: theme.palette.action.disabledBackground,
                        },
                    },
                    '&:not($disabled)': {
                        '&$checked.invert.contained:hover': {
                            backgroundColor: theme.palette.common.white + "22",
                        },
                        '&$colorPrimary': {
                            '&$checked': {
                                '& .MuiSvgIcon-root': {
                                    backgroundColor: theme.palette.primary.main,
                                    borderColor: theme.palette.primary.main,
                                    color: theme.palette.common.white,
                                },
                                '&.invert, &.contained': {
                                    '& .MuiSvgIcon-root': {
                                        backgroundColor: theme.palette.common.white,
                                        color: theme.palette.primary.main,
                                    },
                                },
                                '&.invert.contained': {
                                    '& .MuiSvgIcon-root': {
                                        backgroundColor: theme.palette.primary.main,
                                        borderColor: theme.palette.common.white,
                                        color: theme.palette.common.white,
                                    },
                                },
                            },
                        },
                        '&$colorSecondary': {
                            '& .MuiSvgIcon-root': {
                                color: 'transparent',
                            },
                            '&$checked': {
                                '& .MuiSvgIcon-root': {
                                    backgroundColor: theme.palette.secondary.main,
                                    borderColor: theme.palette.secondary.main,
                                    color: theme.palette.common.white,
                                },
                                '&.invert, &.contained': {
                                    '& .MuiSvgIcon-root': {
                                        backgroundColor: theme.palette.common.white,
                                        color: theme.palette.secondary.main,
                                    },
                                },
                                '&.invert.contained': {
                                    '& .MuiSvgIcon-root': {
                                        backgroundColor: theme.palette.secondary.main,
                                        borderColor: theme.palette.common.white,
                                        color: theme.palette.common.white,
                                    },
                                },
                            },
                        },
                    },
                    padding: theme.spacing(0.75),
                },
            },
            MuiDrawer: {
                paper: {
                    padding: theme.spacing(2),
                },
                paperAnchorLeft: (_a = {},
                    _a[theme.breakpoints.down('xs')] = {
                        maxWidth: 320,
                    },
                    _a.maxWidth = 400,
                    _a.width = '100%',
                    _a),
                paperAnchorRight: (_b = {},
                    _b[theme.breakpoints.down('xs')] = {
                        maxWidth: 320,
                    },
                    _b.maxWidth = 400,
                    _b.width = '100%',
                    _b),
            },
            MuiFilledInput: {
                adornedEnd: {
                    paddingRight: theme.spacing(2),
                },
                adornedStart: {
                    paddingLeft: theme.spacing(2),
                },
                input: {
                    fontSize: theme.typography.pxToRem(16),
                    height: undefined,
                    letterSpacing: theme.typography.pxToRem(0.15),
                    lineHeight: theme.typography.pxToRem(28),
                    padding: theme.spacing(1, 2),
                },
                inputAdornedEnd: {
                    paddingRight: theme.spacing(0),
                },
                inputAdornedStart: {
                    paddingLeft: theme.spacing(0),
                },
                inputHiddenLabel: {
                    paddingBottom: theme.spacing(1),
                    paddingTop: theme.spacing(1),
                },
            },
            MuiFormControlLabel: {
                label: {
                    margin: theme.spacing(1, 0.25),
                    paddingRight: theme.spacing(1),
                },
                labelPlacementBottom: {
                    '& $label': {
                        margin: theme.spacing(0.25, 0.25),
                        paddingLeft: theme.spacing(1),
                        paddingRight: theme.spacing(1),
                    },
                    justifyContent: 'center',
                    paddingTop: theme.spacing(0.5),
                },
                root: {
                    '&.contained': {
                        '& $label': {
                            fontSize: theme.typography.pxToRem(16),
                            fontWeight: 700,
                            letterSpacing: theme.typography.pxToRem(-0.2),
                            lineHeight: theme.typography.pxToRem(28),
                            margin: theme.spacing(0.5, 0.25),
                        },
                        '&$disabled': {
                            border: "solid 2px " + theme.palette.action.disabled,
                        },
                        '&.checked': {
                            '&.primary': {
                                '&.invert': {
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.primary.contrastText,
                                },
                                border: "solid 2px " + theme.palette.primary.main,
                            },
                            '&.secondary': {
                                '&.invert': {
                                    backgroundColor: theme.palette.secondary.main,
                                    color: theme.palette.secondary.contrastText,
                                },
                                border: "solid 2px " + theme.palette.secondary.main,
                            },
                        },
                        border: "solid 2px " + theme.palette.common.black,
                        borderRadius: theme.shape.borderRadius,
                    },
                    marginLeft: 0,
                    marginRight: 0,
                },
            },
            MuiFormHelperText: {
                contained: {
                    marginLeft: theme.spacing(0),
                    marginRight: theme.spacing(0),
                },
                root: {
                    '&$error': {
                        color: theme.palette.error.dark,
                    },
                    fontSize: theme.typography.pxToRem(12),
                    letterSpacing: theme.typography.pxToRem(0.4),
                    lineHeight: theme.typography.pxToRem(20),
                    marginTop: theme.spacing(0.5),
                },
            },
            MuiFormLabel: {
                root: {
                    '&$error': {
                        color: null,
                    },
                    fontSize: theme.typography.pxToRem(16),
                    lineHeight: theme.typography.pxToRem(28),
                },
            },
            MuiIcon: {
                fontSizeLarge: {
                    fontSize: theme.typography.pxToRem(35),
                },
                fontSizeSmall: {
                    fontSize: theme.typography.pxToRem(20),
                },
                root: {
                    fontSize: theme.typography.pxToRem(24),
                },
            },
            MuiInput: {
                formControl: {
                    'label + &': {
                        marginTop: theme.spacing(1),
                    },
                },
            },
            MuiInputAdornment: {
                filled: {
                    '&$positionStart:not($hiddenLabel)': {
                        marginTop: theme.spacing(0),
                    },
                },
                root: {
                    fontSize: theme.typography.pxToRem(16),
                    letterSpacing: theme.typography.pxToRem(0.15),
                    lineHeight: theme.typography.pxToRem(28),
                },
            },
            MuiInputBase: {
                adornedEnd: {
                    paddingRight: theme.spacing(2),
                },
                adornedStart: {
                    paddingLeft: theme.spacing(2),
                },
                formControl: {
                    'label + &': {
                        marginTop: theme.spacing(1),
                    },
                },
                input: {
                    fontSize: theme.typography.pxToRem(16),
                    height: undefined,
                    letterSpacing: theme.typography.pxToRem(0.15),
                    lineHeight: theme.typography.pxToRem(28),
                    padding: theme.spacing(1, 2),
                },
                inputAdornedEnd: {
                    paddingRight: theme.spacing(0),
                },
                inputAdornedStart: {
                    paddingLeft: theme.spacing(0),
                },
                root: {
                    '&$disabled': {
                        backgroundColor: theme.palette.grey[100],
                    },
                },
            },
            MuiInputLabel: {
                filled: {
                    '&$shrink': {
                        transform: 'none',
                    },
                    pointerEvents: 'auto',
                    transform: 'none',
                },
                formControl: {
                    left: undefined,
                    position: 'static',
                    top: undefined,
                    transform: 'none',
                },
                outlined: {
                    '&$shrink': {
                        transform: 'none',
                    },
                    pointerEvents: 'auto',
                    transform: 'none',
                },
                shrink: {
                    transform: 'none',
                },
            },
            MuiLinearProgress: {
                barColorPrimary: {
                    backgroundColor: theme.palette.secondary.main,
                },
            },
            MuiLink: {
                button: {
                    verticalAlign: 'inherit',
                },
                root: {
                    fontWeight: 700,
                    letterSpacing: theme.typography.pxToRem(-0.2),
                    textUnderlineOffset: '4px',
                },
                underlineHover: {
                    '&:hover': {
                        textDecorationThickness: '2px',
                    },
                },
            },
            MuiMobileStepper: {
                dot: {
                    '&$dotActive': {
                        backgroundColor: theme.palette.secondary.main,
                    },
                    backgroundColor: theme.palette.secondary.light,
                },
                progress: {
                    backgroundColor: theme.palette.secondary.light,
                },
            },
            MuiOutlinedInput: {
                adornedEnd: {
                    paddingRight: theme.spacing(2),
                },
                adornedStart: {
                    paddingLeft: theme.spacing(2),
                },
                input: {
                    fontSize: theme.typography.pxToRem(16),
                    height: undefined,
                    letterSpacing: theme.typography.pxToRem(0.15),
                    lineHeight: theme.typography.pxToRem(28),
                    padding: theme.spacing(1, 2),
                },
            },
            MuiPaper: {
                outlined: {
                    background: 'none',
                    border: "solid 2px " + theme.palette.secondary.main,
                    margin: '-1px 0',
                },
            },
            MuiPickersCalendarHeader: {
                switchHeader: {
                    '& .MuiPickersCalendarHeader-iconButton': {
                        '&.Mui-disabled': {
                            color: theme.palette.action.disabled,
                        },
                        backgroundColor: theme.palette.background.default,
                        color: theme.palette.secondary.main,
                    },
                },
            },
            MuiPickersClock: {
                clock: {
                    backgroundColor: theme.palette.background.default,
                    border: "1px solid " + theme.palette.divider,
                },
                pin: {
                    backgroundColor: theme.palette.secondary.main,
                },
            },
            MuiPickersClockNumber: {
                clockNumberSelected: {
                    backgroundColor: theme.palette.secondary.main,
                },
            },
            MuiPickersClockPointer: {
                pointer: {
                    backgroundColor: theme.palette.secondary.main,
                },
                thumb: {
                    borderColor: theme.palette.secondary.main,
                },
            },
            MuiPickersDatePickerRoot: {
                toolbar: {
                    '& ~ .MuiPickersBasePicker-pickerView': {
                        '& .MuiPickersCalendarHeader-switchHeader': {
                            '& .MuiPickersCalendarHeader-iconButton': {
                                backgroundColor: theme.palette.grey[50],
                            },
                            backgroundColor: theme.palette.grey[50],
                            marginTop: theme.spacing(-0.5),
                        },
                    },
                    backgroundColor: theme.palette.secondary.main,
                },
            },
            MuiPickersDay: {
                current: {
                    color: theme.palette.secondary.main,
                },
                day: {
                    borderRadius: theme.spacing(1),
                    color: theme.palette.secondary.dark,
                },
                dayDisabled: {
                    color: theme.palette.action.disabled,
                },
                daySelected: {
                    '&:hover': {
                        backgroundColor: theme.palette.secondary.light,
                    },
                    backgroundColor: theme.palette.secondary.main,
                    borderRadius: theme.spacing(1),
                },
            },
            MuiPickersMonth: {
                root: __assign({ '&$monthSelected': __assign({}, theme.typography.h2) }, theme.typography.body1),
            },
            MuiPickersTimePickerToolbar: {
                ampmSelection: {
                    '& h6': __assign({}, theme.typography.h5),
                    marginLeft: '10px',
                    marginRight: 0,
                    maxHeight: '50px',
                },
                hourMinuteLabel: {
                    '& h2': {
                        fontSize: theme.typography.subtitle1.fontSize,
                        fontWeight: 'bold',
                    },
                    alignItems: 'flex-start',
                },
            },
            MuiPickersToolbar: {
                toolbar: {
                    backgroundColor: theme.palette.secondary.main,
                },
            },
            MuiPickersToolbarButton: {
                toolbarBtn: {
                    '& h4': __assign({}, theme.typography.h2),
                    '& h6': __assign({}, theme.typography.body1),
                },
            },
            MuiPickersYear: {
                root: __assign({}, theme.typography.body1),
                yearSelected: __assign({}, theme.typography.h2),
            },
            MuiRadio: {
                root: {
                    '& .iconBase': {
                        border: "solid 2px " + theme.palette.common.black,
                        borderRadius: '50%',
                        height: '24px',
                        width: '24px',
                    },
                    '&$checked': {
                        '& .iconBase': {
                            '&:before': {
                                backgroundImage: 'radial-gradient(transparent,transparent 40%,#fff 45%)',
                                borderRadius: '50%',
                                content: '""',
                                display: 'block',
                                height: 20,
                                width: 20,
                            },
                        },
                        '&$colorPrimary .iconBase': {
                            backgroundColor: theme.palette.primary.main,
                            border: "solid 2px " + theme.palette.primary.main,
                        },
                        '&$colorSecondary .iconBase': {
                            backgroundColor: theme.palette.secondary.main,
                            border: "solid 2px " + theme.palette.secondary.main,
                        },
                        '&.contained.invert .iconBase': {
                            '&:before': {
                                margin: '-2px -2px',
                            },
                            border: "solid 4px " + theme.palette.common.white,
                        },
                    },
                    '&$disabled': {
                        '& .iconBase': {
                            backgroundColor: theme.palette.action.disabledBackground,
                            border: "solid 2px " + theme.palette.action.disabled,
                        },
                    },
                    padding: theme.spacing(0.75),
                },
            },
            MuiSelect: {
                icon: {
                    right: theme.spacing(1),
                    top: undefined,
                },
                iconFilled: {
                    right: theme.spacing(1),
                },
                iconOutlined: {
                    right: theme.spacing(1),
                },
            },
            MuiStep: {
                completed: {
                    cursor: 'pointer',
                },
            },
            MuiStepButton: {
                root: {
                    '& .MuiStepLabel-labelContainer': {
                        '& > span:not(.MuiStepLabel-label)': {
                            position: 'static',
                        },
                    },
                    '&$horizontal': {
                        textAlign: 'left',
                    },
                    boxSizing: 'border-box',
                },
            },
            MuiStepConnector: {
                root: {
                    visibility: 'hidden',
                },
            },
            MuiStepIcon: {
                root: {
                    '&$active': {
                        '& .MuiStepIcon-text': {
                            fill: theme.palette.secondary.contrastText,
                        },
                        color: theme.palette.secondary.main,
                    },
                    '&$completed': {
                        border: "solid 2px " + theme.palette.success.main,
                        borderRadius: '50%',
                        color: theme.palette.success.main,
                        padding: '2px',
                    },
                    color: theme.palette.secondary.main + "14",
                    height: '32px',
                    width: '32px',
                },
                text: {
                    fill: theme.palette.secondary.dark,
                    fontWeight: 700,
                },
            },
            MuiStepLabel: {
                alternativeLabel: {
                    '& $labelContainer': {
                        textAlign: 'center',
                    },
                },
                horizontal: {
                    alignItems: 'initial',
                },
                label: (_c = {
                        '& ~ span': {
                            color: theme.palette.secondary.dark,
                        },
                        '&$active': {
                            '& ~ span': {
                                color: theme.palette.secondary.main,
                            },
                            color: theme.palette.secondary.main,
                            fontWeight: 800,
                        },
                        '&$alternativeLabel': {
                            marginTop: theme.spacing(1),
                        },
                        '&$completed': {
                            '& ~ span': {
                                color: darken(theme.palette.success.main, 0.6),
                            },
                            color: darken(theme.palette.success.main, 0.6),
                            fontWeight: 800,
                        },
                        '&$error': {
                            '& ~ span': {
                                color: darken(theme.palette.error.main, 0.6),
                            },
                            color: darken(theme.palette.error.main, 0.6),
                            fontWeight: 800,
                        }
                    },
                    _c[theme.breakpoints.down('xs')] = {
                        fontSize: theme.typography.pxToRem(11),
                    },
                    _c.color = theme.palette.secondary.dark,
                    _c.fontSize = theme.typography.pxToRem(14),
                    _c.fontWeight = 800,
                    _c),
                labelContainer: {
                    '& > $alternativeLabel:only-child': {
                        paddingTop: 0,
                    },
                    '& > span:not($label)': {
                        position: 'relative',
                        top: theme.spacing(-0.5),
                    },
                    '& > span:only-child': {
                        paddingTop: theme.spacing(0.5),
                    },
                },
                root: {
                    '&$alternativeLabel': {
                        alignItems: 'center',
                    },
                    '&$error': {
                        '& $iconContainer > svg': {
                            backgroundColor: theme.palette.error.main,
                            borderRadius: '50%',
                            color: '#fff',
                            height: '32px',
                            padding: theme.spacing(0.25, 0.5, 0.75),
                            width: '32px',
                        },
                    },
                },
            },
            MuiStepper: {
                horizontal: {
                    alignItems: 'flex-start',
                },
                root: {
                    padding: theme.spacing(1),
                },
            },
            MuiSvgIcon: {
                fontSizeLarge: {
                    fontSize: theme.typography.pxToRem(35),
                },
                fontSizeSmall: {
                    fontSize: theme.typography.pxToRem(20),
                },
                root: {
                    fontSize: theme.typography.pxToRem(24),
                },
            },
            MuiSwitch: {
                colorPrimary: {
                    '&$checked': {
                        '& + $track': {
                            backgroundColor: theme.palette.secondary.main,
                            borderColor: theme.palette.secondary.main,
                            opacity: 1,
                        },
                        color: theme.palette.background.default,
                    },
                },
                colorSecondary: {
                    '&$checked': {
                        color: theme.palette.background.default,
                    },
                },
                root: {
                    '& $thumb': {
                        height: 36,
                        width: 36,
                    },
                    alignItems: 'center',
                    display: 'flex',
                    height: 44,
                    padding: 0,
                    width: 84,
                },
                sizeSmall: {
                    '& $checked$switchBase': {
                        transform: 'translateX(40px)!important',
                    },
                    '& $thumb': {
                        borderRadius: 20,
                        height: 28,
                        width: 36,
                    },
                    alignItems: 'center',
                    display: 'flex',
                    height: 36,
                    padding: 0,
                    width: 84,
                },
                switchBase: {
                    '&$checked': {
                        '& + $track': {
                            backgroundColor: theme.palette.secondary.main,
                            borderColor: theme.palette.secondary.main,
                            opacity: 1,
                        },
                        transform: 'translateX(40px)',
                    },
                    color: theme.palette.secondary.main,
                    left: 'unset',
                    padding: 4,
                    top: 'unset',
                },
                track: {
                    backgroundColor: theme.palette.secondary.main + "14",
                    borderRadius: 22,
                    opacity: 1,
                },
            },
            MuiToggleButton: {
                root: {
                    '& .MuiSvgIcon-root': {
                        margin: theme.spacing(0, -0.75),
                    },
                    '&$selected': {
                        '&:hover': null,
                        backgroundColor: theme.palette.secondary.main,
                        color: theme.palette.secondary.contrastText,
                    },
                    '&$selected:not(.MuiToggleButtonGroup-grouped)': {
                        backgroundColor: theme.palette.secondary.main,
                        border: '1px solid transparent',
                        color: theme.palette.common.white,
                    },
                    '&:hover': {
                        backgroundColor: theme.palette.secondary.main,
                        color: theme.palette.secondary.contrastText,
                    },
                    '&:not(.MuiToggleButtonGroup-grouped)': {
                        '& .MuiSvgIcon-root': {
                            margin: theme.spacing(0, -0.75),
                        },
                        background: theme.palette.common.white,
                        border: '1px solid black',
                        borderRadius: '8px',
                        color: 'black',
                        lineHeight: '26px',
                        padding: theme.spacing(1, 2),
                    },
                    border: 0,
                    borderRadius: '20px',
                    color: theme.palette.secondary.dark,
                    fontSize: '16px',
                    lineHeight: '28px',
                    padding: theme.spacing(0.75, 1.5),
                },
                sizeLarge: {
                    '& .MuiSvgIcon-root': {
                        margin: theme.spacing(0, -0.5),
                    },
                    fontSize: '16px',
                    lineHeight: '32px',
                    padding: theme.spacing(1, 1.5),
                },
                sizeSmall: {
                    '& .MuiSvgIcon-root': {
                        margin: theme.spacing(0, -0.75),
                    },
                    fontSize: '14px',
                    lineHeight: '24px',
                    padding: theme.spacing(0.25, 1.5),
                },
            },
            MuiToggleButtonGroup: {
                root: {
                    '& $grouped$groupedHorizontal': {
                        borderRadius: '20px',
                    },
                    backgroundColor: theme.palette.secondary.main + "14",
                    borderRadius: '20px',
                    padding: theme.spacing(0.5),
                },
            },
            MuiTooltip: {
                arrow: {
                    '&::before': {
                        boxShadow: theme.shadows[1],
                    },
                    color: theme.palette.grey[50],
                },
                tooltip: {
                    backgroundColor: theme.palette.grey[50],
                    boxShadow: theme.shadows[1],
                    color: theme.palette.text.primary,
                    fontSize: theme.typography.pxToRem(10),
                    fontWeight: 700,
                    lineHeight: theme.typography.pxToRem(14),
                    padding: theme.spacing(1, 1.5),
                },
            },
        }, props: {
            MuiAccordion: {
                square: true,
            },
            MuiAccordionSummary: {
                expandIcon: createElement(IconChevronDown),
            },
            MuiAlert: {
                iconMapping: {
                    error: createElement(Error),
                    info: createElement(Info),
                    success: createElement(CheckCircle),
                    warning: createElement(Warning),
                },
            },
            MuiAppBar: {
                elevation: 0,
            },
            MuiAutocomplete: {
                popupIcon: createElement(IconChevronDown),
            },
            MuiButton: {
                centerRipple: true,
                disableElevation: true,
            },
            MuiCheckbox: {
                checkedIcon: createElement(IconCheckBox, { viewBox: '4 4 16 16' }),
                icon: createElement(IconCheckBoxOutlineBlank, { viewBox: '6 6 12 12' }),
                indeterminateIcon: createElement(IconIndeterminateCheckBox, { viewBox: '4 4 16 16' }),
            },
            MuiDrawer: {
                elevation: 16,
            },
            MuiLink: {
                color: 'secondary',
                variant: 'body1',
            },
            MuiOutlinedInput: { notched: false },
            MuiPaper: {
                elevation: 0,
            },
            MuiRadio: {
                checkedIcon: createElement('span', { className: 'iconBase' }),
                icon: createElement('span', { className: 'iconBase' }),
            },
            MuiSelect: {
                IconComponent: IconChevronDown,
            },
            MuiTextField: {
                color: 'secondary',
                variant: 'outlined',
            },
        } }));
};
